import { createContext, useContext, useReducer, type Dispatch } from 'react'

type RPSState = {
  [key: string]: any
}

export const RPSContext = createContext({} as RPSState)
// const RPSDispatchContext = createContext(null)

// export function RPSProvider({ children }: any) {
//   const [tasks, dispatch] = useReducer(rpsReducer, initialRPSState)

//   return (
//     <RPSContext.Provider value={tasks}>
//       <RPSDispatchContext.Provider value="">{children}</RPSDispatchContext.Provider>
//     </RPSContext.Provider>
//   )
// }

// export function useRPS() {
//   return useContext(RPSContext)
// }

// export function useRPSDispatch() {
//   return useContext(RPSDispatchContext)
// }

// function rpsReducer(tasks: any, action: any) {
//   switch (action.type) {
//     case 'added': {
//       return [
//         ...tasks,
//         {
//           id: action.id,
//           text: action.text,
//           done: false,
//         },
//       ]
//     }
//     case 'changed': {
//       return tasks.map((t: any) => {
//         if (t.id === action.task.id) {
//           return action.task
//         } else {
//           return t
//         }
//       })
//     }
//     case 'deleted': {
//       return tasks.filter((t: any) => t.id !== action.id)
//     }
//     default: {
//       throw Error('Unknown action: ' + action.type)
//     }
//   }
// }

// export {}
